import r from"styled-components";import{theme as e}from"../../../theme.js";import{PollTypeEnum as n}from"./Poll.interface.js";const a=({pollType:o,correct:i,userChoice:t})=>o===n.poll&&t?`2px solid ${e.colors.primary[500]}`:o===n.trivia&&t?i?"2px solid #00C853B2":"2px solid #FF9999B2":"none",p=({pollType:o,correct:i})=>o===n.trivia?i?"#00C853B2":"#FF9999B2":o===n.poll?e.colors.primary[300]:"unset",l=r.div`
  height: 500px;
  @media screen and (max-width: ${e.breakpoints.lg}) {
    height: auto;
  }
`,s=r.div`
  padding: ${e.spacing*4}px;
  border-radius: ${e.radius}px;
  box-shadow: ${e.boxShadow};
  display: flex;
  flex-direction: column;
  gap: ${e.spacing*4}px;
  z-index: 50;
  position: relative;
  max-height: 500px;
  overflow: hidden;
  transition: max-height .5s ease-out;
  background: #fff;
  position: relative;
  &:hover {
    max-height: 1000px;
  }
  .loading {
    backdrop-filter: blur(1px);
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.8);
    border-radius: ${e.radius}px;
    z-index: 52;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      width: 60px;
      height: 60px;
      > circle {
        stroke: ${e.colors.primary[500]};
      }
    }
  }
  @media screen and (max-width: ${e.breakpoints.lg}) {
    max-height: unset;
    &:hover {
      max-height: unset;
    }
  }
`,c=r.button`
  background-color: ${e.colors.gray[100]};
  color: ${e.colors.gray[900]};
  border-radius: ${e.radius}px;
  border: none;
  outline: none;
  width: 100%;
  padding: ${e.spacing*3}px ${e.spacing*6}px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${e.spacing*3}px;
  > span {
    position: relative;
    z-index: 2;
    line-height: 24px;
    font-size: 14px;
    font-weight: 700;
    text-align: left;
  }
  position: relative;
  box-sizing: border-box;
  outline: ${({userChoice:o,correct:i,pollType:t})=>a({pollType:t,correct:i,userChoice:o})};
  &:after {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    max-width: 100%;
    width: ${({percentage:o})=>o}%;
    content: "";
    background-color: ${({correct:o,pollType:i})=>p({pollType:i,correct:o})};
    border-radius: ${e.radius}px;
    z-index: 1;
    display: ${({userAnswered:o})=>o?"block":"none"};
  }
`,d=r.div`
  > img {
    aspect-ratio: 16/9;
    object-fit: cover;
    width: 100%;
    border-radius: ${e.radius}px;
  }
`,x=r.h3`
  font-size: 20px;
  margin: 0;
  color: ${e.colors.gray[900]};
  line-height: 30px;
`,g=r.span`
  margin: 0;
  &.response {
    color: ${e.colors.gray[900]};
    line-height: 24px;
  }
  &.votes-count {
    color: ${e.colors.gray[500]};
    line-height: 16px;
    font-size: 14px;
  }
`;export{c as AnswerButton,s as Container,d as ImageContainer,g as PollFooterLabel,l as PollWrapper,x as Title};
